// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["vue"], () => (__webpack_require__("./webpack-view-room-details.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["vue"], () => (__webpack_require__("./webpack-view-room-details.css")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
